// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore, connectFirestoreEmulator, setLogLevel } from "firebase/firestore";
import { getAuth, connectAuthEmulator, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import environmentConfig from './config/environment';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Firebase configuration is injected via environment variables so we can
// point the same codebase at different Firebase projects (emulator vs. live)
// without code changes.  CRA exposes only variables prefixed with REACT_APP_.

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);

// Ensure auth persists across reloads and sessions
setPersistence(auth, browserLocalPersistence).catch(() => {});

// Always enable verbose Firestore logs during local testing
setLogLevel('debug');
// console.log('[Firebase] Firestore debug logging active');

// Safari + ngrok often require long-polling and disabling fetch streams.
// @ts-ignore – useFetchStreams is experimental and may not be in typings yet.
const firestoreOptions = {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
};

let db = initializeFirestore(app, firestoreOptions);

// Use environment config to determine emulator usage
const envConfig = environmentConfig.getFirebaseConfig();

if (envConfig.useEmulators) {
  console.log("🔧 Using Firebase emulators (Environment: Emulator)");
  // Point to the Auth emulator
  connectAuthEmulator(auth, envConfig.authUrl);
  // Re-init Firestore with emulator options (port must be specified *after* init)
  connectFirestoreEmulator(db, envConfig.firestoreHost, envConfig.firestorePort);
  // Connect to Storage emulator
  connectStorageEmulator(storage, envConfig.storageHost, envConfig.storagePort);
} else {
  console.log("🌐 Using Production Firebase");
}

export { auth, db, storage };